// DO NOT EDIT THIS FILE. It should be automatically generated by running
// pnpm generate-product-schemas
import { format } from 'date-fns/format'
import { sub } from 'date-fns/sub'
import * as z from 'zod'

import * as constants from '@nxt-insurance/constants'

// This is the base schema that can be extended when using it in configs
export const BaseSchema_ContentsV1GetsafeDe = z.object({
  town: z.string().min(1),
  street: z.string().min(1),
  born_on: z
    .union([z.number(), z.string(), z.date()])
    .pipe(
      z.coerce
        .date()
        .min(sub(new Date(), { years: 120 }))
        .max(sub(new Date(), { years: 18 }))
    )
    .transform((value) => {
      return format(value, constants.SERVER_DATE_FORMAT)
    }),
  house_no: z.string().min(1),
  zip_code: z
    .string()
    .min(1)
    .regex(/^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/),
  flatmates: z
    .array(z.object({ last_name: z.string().min(1), first_name: z.string().min(1) }))
    .max(5)
    .optional(),
  tariff_line: z.enum(['comfort', 'premium']),
  glass_coverage: z.boolean(),
  deductible_amount: z.coerce
    .string()
    .pipe(z.enum(['0', '250', '500']))
    .pipe(z.coerce.number()),
  insured_sum_amount: z.preprocess((val) => {
    if (val === '' || val === undefined) {
      return undefined
    }
    return Number(val)
  }, z.number().int().gte(10_000).lte(250_000)),
  bike_theft_coverage: z.boolean(),
  living_space_square_meters: z.preprocess((val) => {
    if (val === '' || val === undefined) {
      return undefined
    }
    return Number(val)
  }, z.number().int().gte(20).lte(350)),
  natural_disasters_coverage: z.boolean(),
  number_of_claims_in_last_5y: z.coerce
    .string()
    .pipe(z.enum(['0', '1', '2']))
    .pipe(z.coerce.number())
    .optional(),
  bike_theft_insured_sum_amount: z
    .preprocess((val) => {
      if (val === '' || val === undefined) {
        return undefined
      }
      return Number(val)
    }, z.number().int().gte(500).lte(5000))
    .optional(),
  cancelled_by_previous_insurer: z.coerce
    .string()
    .pipe(z.enum(['false']))
    .transform(() => false)
    .optional(),
  previous_insurance_in_last_5y: z.boolean().optional(),
  permanent_residence_in_germany: z.coerce
    .string()
    .pipe(z.enum(['true']))
    .transform(() => true)
    .optional(),
})

const Schema_ContentsV1GetsafeDe = BaseSchema_ContentsV1GetsafeDe.superRefine((values, ctx) => {
  if (
    values['previous_insurance_in_last_5y'] !== undefined &&
    [true].includes(values['previous_insurance_in_last_5y'])
  ) {
    if (values['number_of_claims_in_last_5y'] === undefined) {
      ctx.addIssue({
        code: z.ZodIssueCode.invalid_type,
        expected: 'integer',
        received: 'undefined',
        message: 'Required',
        path: ['number_of_claims_in_last_5y'],
      })
    }
  }
})
  .superRefine((values, ctx) => {
    if (
      values['bike_theft_coverage'] !== undefined &&
      [true].includes(values['bike_theft_coverage'])
    ) {
      if (values['bike_theft_insured_sum_amount'] === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.invalid_type,
          expected: 'integer',
          received: 'undefined',
          message: 'Required',
          path: ['bike_theft_insured_sum_amount'],
        })
      }
    }
  })
  .superRefine((values, ctx) => {
    if (
      values['previous_insurance_in_last_5y'] !== undefined &&
      [true].includes(values['previous_insurance_in_last_5y'])
    ) {
      if (values['cancelled_by_previous_insurer'] === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.invalid_type,
          expected: 'boolean',
          received: 'undefined',
          message: 'Required',
          path: ['cancelled_by_previous_insurer'],
        })
      }
    }
  })

export default Schema_ContentsV1GetsafeDe
